export default __webpack_public_path__ + "static/media/kazakhstan.58cd6e0d.jpg";